module.exports = __webpack_public_path__ + "img/video-6.de443d30.png";